<template>
  <div class="styles">
    <div
      :class="{ selected: selectedType === 'Bezier' }"
      class="style curved"
      @click="onChangeStyle((type = 'Bezier'))"
    >
      <svg-icon
        :width="'22'"
        :height="'22'"
        icon="app-icons/connection-bezier"
        :fill="selectedType === 'Bezier' ? '#fff' : '#555'"
      />
    </div>
    <div class="divider" />
    <div
      :class="{ selected: selectedType === 'Straight' }"
      class="style straight"
      @click="onChangeStyle((type = 'Straight'))"
    >
      <svg-icon
        :width="'22'"
        :height="'22'"
        icon="app-icons/connection-straight"
        :fill="selectedType === 'Straight' ? '#fff' : '#555'"
      />
    </div>
    <div class="divider" />
    <div
      :class="{ selected: selectedType === 'Flowchart' }"
      class="style flowchart"
      @click="onChangeStyle((type = 'Flowchart'))"
    >
      <svg-icon
        :width="'22'"
        :height="'22'"
        icon="app-icons/connection-flowchart"
        :fill="selectedType === 'Flowchart' ? '#fff' : '#555'"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SvgIcon from './SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },

  computed: {
    ...mapGetters('project/config/connections', ['getSelections']),
    ...mapGetters('project/data/connections', ['getNodes']),

    /**
     * The preselected connection type
     */
    selectedType() {
      // Get the type for every connection in the selection
      const types = this.getNodes(this.getSelections).map(c => c.type);
      // If they are all the same then select this type
      if (types && types.every(t => t === types[0])) {
        return types[0];
      }
      // If they differ no type selected
      return null;
    },
  },

  methods: {
    ...mapActions('project/data/connections', {
      updateConnection: 'customUpdate',
    }),
    ...mapActions('project/config/connections', {
      setDefaultStyle: 'setDefaultStyle',
    }),

    /**
     * Event handler: the user selects another connection style
     */
    onChangeStyle(type) {
      this.getSelections.forEach(id => {
        this.updateConnection({
          id,
          props: {
            type,
          },
          apply: false,
        });
      });

      // Also set the type for the default connection style
      this.setDefaultStyle({
        props: { type },
        apply: true,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.styles {
  display: flex;
  // padding: 10px 12px;
  justify-content: space-between;
  width: 100%;
  cursor: default;
  .divider {
    width: 1px;
    height: 34px;
    background: #313838;
  }
  .style {
    cursor: pointer;
    width: 33%;
    height: 34px;
    // border-radius: 4px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    &.selected,
    &:hover {
      // background: #2d3233;
    }
  }
}
</style>
